import {assert} from 'Asserts';

import {SimpleRule, SimpleRuleInput} from './types';

export function getInputForSimpleRule(
  simpleRules: Array<SimpleRule>,
  validationRuleTemplateId: string,
  inputKey: string
): SimpleRuleInput | null {
  const simpleRule = simpleRules.find((rule) => rule.validationRuleTemplateId === validationRuleTemplateId);
  if (!simpleRule) {
    return null;
  }
  assert(
    simpleRule.constantInputs.hasOwnProperty(inputKey),
    `Input key '${inputKey}' not found in simple rule.`
  );
  return simpleRule.constantInputs[inputKey];
}

export function doesSimpleRuleExist(
  simpleRules: Array<SimpleRule>,
  validationRuleTemplateId: string
): boolean {
  const simpleRule = simpleRules.find((rule) => rule.validationRuleTemplateId === validationRuleTemplateId);
  return simpleRule != null;
}

export const validationRuleTemplateIdToDisplayName: Record<string, string> = {
  // boolean rules
  svdrltmpl_booleanfieldequals: 'Equals',

  // integer rules
  svdrltmpl_integerfielddisallowedvalue: 'Cannot Equal',
  svdrltmpl_integerfieldminvalue: 'Min Value',
  svdrltmpl_integerfieldmaxvalue: 'Max Value',

  // float rules
  svdrltmpl_floatfielddisallowedvalue: 'Cannot Equal',
  svdrltmpl_floatfieldminvalue: 'Min Value',
  svdrltmpl_floatfieldmaxvalue: 'Max Value',

  // text rules
  svdrltmpl_textfieldnotequals: 'Cannot Equal',
  svdrltmpl_textfieldcontains: 'Contains',
  svdrltmpl_textfieldnotcontains: "Doesn't Contain",
};
